export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/caigouhetonglvyuebaoxian-aa93c7110b70b8369a60953056dd62e1.png";